import React from "react";
import Snackbar from "@mui/material/Snackbar";

const Notification = (props) => {
    const { open, onClose, message, autoHideDuration } = props;

    return (
        <Snackbar
            anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
            }}
                open={open}
                autoHideDuration={autoHideDuration}
                onClose={onClose}
                ContentProps={{
                    "aria-describedby": "message-id",
                }}
                message={<span id="message-id">{message}</span>}
        />
    );
}

export default Notification;
